import AgentResultListView from "views/agents/agentResultListView";
import NewResearchResultListItemView from "views/research/newResearchResultListItemView";

class NewResearchResultListView extends AgentResultListView {}

NewResearchResultListView.prototype.itemView = NewResearchResultListItemView;

export default NewResearchResultListView;
